// components/Projects.js
import React from 'react';
import { PROJECTS } from '../Constants';

const Projects = () => {
  return (
    <section id="projects" className="p-8 w-full  bg-gradient-to-r from-blue-400 to-purple-600">
      <h2 className="text-3xl font-bold text-center mb-6">Projects</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 ">
        {PROJECTS.map((project, index) => (
          <div key={index} className="p-6 bg-gray-100 rounded bg-gradient-to-r from-blue-400 to-purple-600 p-4 shadow-lg">
            <h3 className="text-2xl mb-2">{project.title}</h3>
            <p className="mb-2">{project.description}</p>
            <p className="text-sm text-gray-600 mb-4">Technologies: {project.tech}</p>
            <a href={project.link} className="text-blue-800">View Project</a>
          </div>
        ))}
      </div>

    </section>
  );
}

export default Projects;
